import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Manual Stacker",
  intro : [
    "Hand stackers is hand push & hand lift stacker which provides cost – effective, handling for both vehicle loading and production areas.",
  ],
  features: [
    "Robust steel profile construction.",
    "Easy maintenance and low running costs.",
    "Sturdy and compact enough to fit through standard door and to operate in congested areas.",
    "Lifting function operated by foot and hand controls.",
    "Heavy duty C-shaped steel construction for strength and rigidity.",
  ],
  imageUrl: "/images/manual-stacker.png"
}

const ManualStacker = () => {
  return (
  <>
  <DetailCard lists={value} />
  </>
  )
}

export default ManualStacker